export default __webpack_public_path__ + "static/media/goods11.9cdf6640.png";